import styled from 'styled-components';

export const StyledToggleWrapper = styled.div`
    background: var(--white);
    background-position: 50% 50%;
    background-size: 100%;
    border-radius: 4px;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12);
    cursor: pointer;
    display: inline-block;
    font-size: 0.9411764706rem;
    font-weight: bold;
    line-height: 46px;
    outline: 0 !important;
    padding: 0 1.7647058824rem;
    text-align: center;
    text-decoration: none !important;
    transition:
        box-shadow 0.16s ease-out,
        background 0.2s ease-out;
    user-select: none;

    color: var(--textDark) !important;
    font-weight: normal;

    font-size: 0.7058823529rem;
    line-height: 28px;
    height: 28px;
    padding: 0 15px;
    padding-left: 58px;

    position: relative;

    flex: none;

    &:hover {
        background-size: 250%;
        box-shadow: 0 5px 15px 0 rgba(0, 0, 0, 0.2);
    }

    &:focus,
    &.is-active {
        box-shadow: 0 5px 15px 0 rgba(0, 0, 0, 0.2);
    }

    &:active {
        transform: scale(1.15);
    }

    @media (max-width: 767px) {
        line-height: 38px;
        height: 38px;
    }
`;

export const StyledToggleContainer = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
    margin-left: 15px;

    @media (max-width: 767px) {
        .react-toggle {
            top: 3px !important;
        }
    }
`;

export const StyledToggleLabel = styled.span`
    display: inline-block;
    height: 28px;
    line-height: 28px;
`;

export const StyledBadge = styled.span`
    top: -4px;
    right: -15px;
    z-index: 2;
`;
